// extracted by mini-css-extract-plugin
export default {"container":"Single_container__-RmFr","wrapper":"Single_wrapper__BtITM"};